import { useCallback, useState } from 'react';
import { ExcelExportFormValues } from '../types';

export interface UseExcelExportFormProps {
  initialFormValues: ExcelExportFormValues;
}

export const useExcelExportForm = ({ initialFormValues }: UseExcelExportFormProps) => {
  const [formValues, setFormValues] = useState<ExcelExportFormValues>(initialFormValues);

  const updateFormValues = useCallback((updates: Partial<ExcelExportFormValues>) => {
    setFormValues((prev: ExcelExportFormValues) => ({ ...prev, ...updates }));
  }, []);

  const resetFormValues = useCallback(() => {
    setFormValues(initialFormValues);
  }, [initialFormValues]);

  return {
    formValues,
    setFormValues,
    updateFormValues,
    resetFormValues,
  };
};
